import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import Products from "../pages/Products";
import Product from "../pages/Product";
import Folders from "../pages/Folders";
import Reviews from "../pages/Reviews";
import Review from '../pages/Review';
import Landing from "../pages/Dashboard/Landing";
import Points from '../pages/Points';

const DashboardContentNavigator = () =>{
  return (
    <Switch>
        <Route exact path="/points" component={Points}/>
        <Route exact path="/products" component={Products}/>
        <Route exact path="/products/:id" component={Product}/>
        <Route exact path="/folders" component={Folders}/>
        <Route exact path="/reviews" component={Reviews}/>
        <Route exact path="/reviews/:id" component={Review}/>
        <Route exact path="/dashboard" component={Landing}/>
        <Redirect to="/dashboard" />
    </Switch>
  );
}
export default DashboardContentNavigator;